import { SessionDataProvider } from "@amzn/awsconsole-web-utils/sessionDataProvider";

interface MetadataProvider {
    getInfrastructureRegion(): Promise<string | undefined>;
    getIdentityToken(): Promise<string | undefined>;
    getSessionARN(): Promise<string | undefined>;
}

export class ConsoleDetection {
    private static instance: ConsoleDetection;
    private cachedResult: boolean | null = null;
    
    private constructor() {}
    
    public static getInstance(): ConsoleDetection {
        if (!ConsoleDetection.instance) {
            ConsoleDetection.instance = new ConsoleDetection();
        }
        return ConsoleDetection.instance;
    }
    
    public async isConsoleApplication(): Promise<boolean> {        
        if (this.cachedResult !== null) {
            return this.cachedResult;
        }
        
        try {
            const metaDataProvider = SessionDataProvider.getInstance();
            this.cachedResult = await this.checkWithProvider(metaDataProvider);
            return this.cachedResult;
        } catch (error) {
            // If there's an error, assume we're not in a console application
            this.cachedResult = false;
            return false;
        }
    }

    public async checkWithProvider(metaDataProvider: MetadataProvider): Promise<boolean> {
        try {
            const infrastructureRegion = await metaDataProvider.getInfrastructureRegion();
            const identityToken = await metaDataProvider.getIdentityToken();
            const sessionARN = await metaDataProvider.getSessionARN();
            
            // If any of these values are truthy, we're in a console application
            return !!(infrastructureRegion || identityToken || sessionARN);
        } catch (error) {
            return false;
        }
    }
}

export async function checkIsConsoleApplication(): Promise<boolean> {
    return ConsoleDetection.getInstance().isConsoleApplication();
}
